// extracted by mini-css-extract-plugin
export default {"root":"MainBanner_root__1iAAq","image":"MainBanner_image__bw9Wx"};